import { render } from "../../templates/selection/finance-question.html?vue&type=template&id=39d30b26"
import script from "./FinanceQuestion.vue?vue&type=script&lang=js"
export * from "./FinanceQuestion.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/lbr.ru/crm/vue_source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__